import React from 'react'
import './contactus.css';

function Contactus() {
  return (
    <div>Contactus</div>
  )
}

export default Contactus